// eslint-disable-next-line no-promise-executor-return
export default (ms): Promise<void> => {
  return new Promise((res) => {
    setTimeout(res, ms);
  });
};
